@if (content && {
selectedAccount: selectedAccount$ | async};
as view) {
<section>
  <p class="c11n-text-lg-bold" [innerText]="mode === 'from-to' ? content.fromToHeader : content.transferFromHeader" data-cy="transferFrom"></p>
  <div class="margin-bottom-1">
    <app-ineligible-accounts [rejectedAccounts]="rejectedAccounts" [isTransferDetailsFrom]="true"></app-ineligible-accounts>
  </div>
  <ng-container>
    <c11n-select [labelText]="content.dropdownLabel" hintText="" [errorText]="content.errorText" [hasError]="hasError">
      <select c11nSelectInput id="selectId" class="c11n-select__box__select" [formControl]="accountFrom"
        attr.aria-label="{{content.aria.from}}">
        <option disabled selected hidden data-option="placeholder" value="" [innerHTML]="content.dropdownPlaceholder">
        </option>
        @for (account of displayedAccounts; track account; let i = $index) {
        <option [value]="i" [innerHTML]="getAccountName(account)"></option>
        }
      </select>
    </c11n-select>

    @if (!!view.selectedAccount?.accountData) {
    <p class="c11n-text-sm">
      {{content.estimatedAccountBalance}} {{view.selectedAccount?.accountData?.dateDisplay }}: {{
      view.selectedAccount?.accountData?.balanceDisplay }}*
    </p>
    }
  </ng-container>
</section>
}
